export default __webpack_public_path__ + "static/media/PRESTIGIO_MARQUINIA-LUCIDO_CRAQUELE_120X278_04_265.2a1d8916.jpg";